(ns dre.pages.admin.feed.views
  (:require
   [dre.components.icon :refer [fa-icon icon]]
   [dre.components.table :refer [table]]
   [dre.components.icons-iconoir :refer [icoinor-icon antd-pagination-icons]]
   [dre.feeds.util :as feeds-util]
   [dre.modals.events :as-alias modals]
   [dre.pages.admin.feed.events :as feed]
   [dre.pages.admin.views :refer [nav-tabs]]
   [reagent.core :as r]
   [dre.app.router :as router]
   [dre.shared.interface.search.blunt :as blunt]
   [dre.shared.interface.search.pills :as pills]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]))

(def component-name :admin-feed)

(defn view
  []
  [:div
   {:class component-name}
   [:div
    {:class (bem/be component-name :nav)}
    [nav-tabs]]
   [:div
    {:class (bem/be component-name :header)}
    [:div
     {:class (bem/be component-name :search-bar)}
     [:input.input
      {:type :text
       :placeholder "Search feeds"
       :on-change #(rf/dispatch [::feed/search-text-on-change (.. % -target -value)])
       :value @(rf/subscribe [::feed/search-text])}]
     [icon :common :search]]
    [:div
     {:class (bem/be component-name :add-new-feed)}
     [:button.button
      {:on-click #(rf/dispatch [::modals/set-modal :admin.feed/add-new-feed
                                {:add {:link ""
                                       :title ""
                                       :feed-id ""
                                       :category ""}}])}
      "Add New Feed"]]]
   [table
    {:pagination {:defaultPageSize 20
                  :showSizeChanger {:suffixIcon (r/as-element [icoinor-icon :nav-arrow-down])}
                  :itemRender antd-pagination-icons}
     :columns [{:title "Feed ID"
                :dataIndex :feed-id
                :sorter :default}
               {:title "Title"
                :render (fn [{:keys [title link]}]
                          [:a
                           {:href link}
                           title])
                :dataIndex :title
                :sorter :default}
               {:title "Category"
                :dataIndex :category
                :sorter :default}
               {:title "Created"
                :dataIndex :_created
                :defaultSortOrder :descend
                :sorter :default}
               {:title "Changed"
                :dataIndex :_modified
                :sorter :default}
               {:title "Count"
                :dataIndex :_count
                :sorter :default
                :render (fn [{:keys [:link :_count :feed-id]}]
                          (let [query [(pills/source-pill (str "feeds:" feed-id))]
                                query-str (blunt/print query)]
                            [:a
                             {:target "_blank"
                              :href (router/->route-with-query-params
                                     (router/->route :search)
                                     {:query query-str})}
                             _count]))}
               {:title "Enabled?"
                :dataIndex :enabled
                :sorter :default
                :render (fn [{:keys [:feed-status :source-id]}]
                          (let [enabled (= feed-status 1)]
                            [:div
                             {:class (bem/be component-name :enabled-cell)}
                             [:input
                              {:type :checkbox
                               :checked enabled
                               :on-click #(rf/dispatch [::feed/toggle-feed {:id source-id}])}]]))}
               {:title "Actions"
                :render (fn [{:keys [:feed-status] :as feed}]
                          (let [enabled (= feed-status 1)]
                            [:div
                             {:class (bem/be component-name :actions-cell)}
                             [:a.edit
                              {:on-click #(rf/dispatch [::modals/set-modal :admin.feed/edit-feed {:edit feed}])}
                              [fa-icon :pen-to-square]]
                             [:a.delete
                              {:on-click (when-not enabled #(rf/dispatch [::modals/set-modal :admin.feed/delete-feed {:delete feed}]))
                               :class (when enabled :disabled)}
                              [fa-icon :trash-can]]]))}]
     :dataSource @(rf/subscribe [::feed/feeds-data])
     :loading? (or @(rf/subscribe [::feed/feeds-loading?])
                   @(rf/subscribe [::feed/feeds-updating?]))}]])
